module.exports = __webpack_public_path__ + "img/activities-22.0e4acaf7.jpg";